export default __webpack_public_path__ + "static/MediaContentTwelve-02d294a0e91a9b40e8f4aac29e5636cf.webp";